import './App.css';
import AddTask from './AddTask';
import { useEffect, useState } from 'react';
import ToDo from './ToDo';
function App() {
  const [taskList, setTaskList] = useState([])
  useEffect(() => {
    let array = localStorage.getItem("taskList");
    if (array) {
      setTaskList(JSON.parse(array))
    }
  }, [])
  return (
    <div className=' w-100'>
      <div className='MainPage h-25  bg-dark  bg-opacity-50 '>
        <h1 className=' mb-5  border-bottom '>Task-Tracker</h1>
      </div>
      <AddTask taskList={taskList} setTaskList={setTaskList} />
      {taskList.map((task, i) =>
        <div className='section w-100 mt-5 d-flex  align-items-center  justify-content-center  '>
          <ToDo task={task} key={i} index={i} taskList={taskList}
            setTaskList={setTaskList} />
        </div>

      )}
    </div>
  );
}

export default App;
